export const id: Record<string, string> = {
    // Bottom nav
    'nav.home': 'Beranda',
    'nav.overtime': 'Lembur',
    'nav.payslip': 'Slip Gaji',
    'nav.account': 'Akun',

    // Common
    'common.loading': 'Memuat…',
    'common.saving': 'Menyimpan…',
    'common.processing': 'Memproses…',
    'common.saved': 'Tersimpan',
    'common.save_failed': 'Gagal menyimpan',
    'common.save': 'Simpan',
    'common.cancel': 'Batal',
    'common.back': 'Kembali',
    'common.close': 'Tutup',
    'common.try_again': 'Coba lagi',

    // Auth
    'auth.login_title': 'Masuk ke Absensi',
    'auth.login_subtitle': 'Pakai akun Satutim kamu untuk mulai absen.',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.login_btn': 'Masuk',
    'auth.login_with_satutim': 'Masuk dengan Satutim',
    'auth.login_with_satutim_hint': 'Aman & sekali klik. Akun terhubung dengan satutim.id.',
    'auth.feature_secure': 'Tanpa input password di app ini',
    'auth.feature_fast': 'Sekali login, langsung clock-in',
    'auth.feature_notif': 'Notifikasi shift, lembur, slip gaji',
    'auth.login_failed': 'Email atau password salah.',
    'auth.sso.exchanging': 'Menghubungkan akun…',
    'auth.sso.failed': 'Tautan masuk sudah kadaluarsa atau tidak valid. Silakan login manual.',
    'auth.logout': 'Keluar',
    'auth.no_account': 'Belum punya akun? Daftar di satutim.id dulu.',

    // Workspace
    'workspace.switch': 'Pindah workspace',
    'workspace.empty': 'Kamu belum tergabung di workspace manapun.',
    'workspace.switch_hint': 'Absen hanya tercatat & terlihat di workspace yang kamu pilih.',
    'workspace.recorded_in': 'Absen tercatat di workspace',
    'workspace.change': 'Ganti',
    'workspace.owned_hint': 'Ini workspace milik kamu sendiri — pastikan bukan workspace kantormu.',
    'workspace.chip_attendance_on': 'Absensi aktif',
    'workspace.chip_attendance_off': 'Absensi belum aktif',
    'workspace.chip_owned': 'Milik kamu',
    'workspace.off_title': 'Absensi belum aktif',
    'workspace.off_body_prefix': 'Absensi belum diaktifkan di workspace',
    'workspace.off_ask_owner': 'Minta owner/admin workspace ini mengaktifkan Absensi, atau pilih workspace lain.',
    'workspace.off_ask_owner_named': 'Minta {owner} (owner workspace ini) mengaktifkan Absensi, atau pilih workspace lain.',
    'workspace.off_others_title': 'Absensi aktif di workspace lain',
    'workspace.off_others_hint': 'Absen untuk kantor? Pilih workspace kantormu supaya absenmu terlihat oleh atasan & HR.',
    'workspace.switch_to': 'Pindah ke {name}',
    'workspace.off_reload': 'Muat ulang',
    'workspace.off_reload_failed': 'Gagal memuat ulang daftar workspace. Server sedang sibuk atau koneksi terputus — coba lagi sebentar lagi.',
    'workspace.owner_warn_title': '{name} adalah workspace milik kamu sendiri',
    'workspace.owner_warn_body': 'Kalau kamu karyawan yang absen untuk kantor, JANGAN aktifkan Absensi di sini. Absen di workspace ini tercatat TERPISAH dan tidak akan terlihat oleh kantormu. Minta admin kantormu mengaktifkan Absensi di workspace kantor, lalu pilih workspace itu.',
    'workspace.owner_warn_ok': 'Aktifkan di sini hanya kalau workspace ini memang untuk usaha/tim kamu sendiri.',
    'workspace.enable_here': 'Aktifkan Absensi di {name}',
    'workspace.enable_confirm': 'Yakin? Semua absen akan tercatat di {name}, terpisah dari absensi kantor lain.',
    'workspace.enable_confirm_others': 'Yakin? Absensi kantormu sudah aktif di workspace lain (lihat di atas). Absen di {name} TIDAK akan terlihat oleh kantormu.',
    'workspace.enable_confirm_btn': 'Ya, aktifkan di sini',
    'workspace.enable_done': 'Absensi aktif di {name}.',
    'workspace.enable_failed': 'Gagal mengaktifkan Absensi. Coba lagi sebentar lagi.',
    'workspace.load_error_title': 'Workspace belum bisa dimuat',
    'workspace.load_error_body': 'Server sedang sibuk atau koneksi terputus. Tunggu sebentar lalu tekan Coba lagi.',

    // Mode
    'mode.office': 'Kantor',
    'mode.wfh': 'WFH',
    'mode.wfa': 'WFA',
    'mode.visit': 'Kunjungan',
    'mode_desc.office': 'Di kantor, perlu GPS & WiFi',
    'mode_desc.wfh': 'Kerja dari rumah',
    'mode_desc.wfa': 'Kerja dari mana saja',
    'mode_desc.visit': 'Visit klien / lapangan',

    // Home / Clock-in
    'home.greeting_morning': 'Selamat pagi',
    'home.greeting_noon': 'Selamat siang',
    'home.greeting_afternoon': 'Selamat sore',
    'home.greeting_evening': 'Selamat malam',
    'home.working': 'Sedang bekerja',
    'home.work_duration': 'durasi kerja',
    'home.shift_remaining': '{duration} lagi sampai shift selesai',
    'home.shift_overtime': 'Shift sudah selesai — kamu lembur {duration}',
    'home.status': 'Status',
    'home.clocked_out_at': 'Sudah clock-out di {time}',
    'home.not_clocked_in': 'Belum clock-in hari ini',
    'home.active_shift': 'Shift aktif',
    'home.streak': '{count} hari',
    'home.policy_blocked_title': 'Belum bisa absen',
    'home.policy_blocked_body': 'Hak absensi kamu belum diatur admin workspace. Hubungi admin untuk dibukakan akses.',
    'home.status_loading': 'Memuat status absensi…',
    'home.status_unavailable': 'Status absensi belum termuat',
    'home.load_error_title': 'Status absensi belum bisa dimuat',
    'home.load_error_body': 'Server sedang sibuk atau koneksi terputus. Data absen kamu aman — tunggu sebentar lalu tekan Coba lagi untuk menampilkan tombol clock-in / clock-out.',

    'home.stats.present': 'Hadir bulan ini',
    'home.stats.late': 'Telat bulan ini',
    'home.stats.overtime': 'Lembur bulan ini',
    'home.stats.avg_in': 'Rata-rata mulai',
    'home.stats.days': 'hari',
    'home.stats.total': 'total',
    'home.stats.per_day': 'per hari',
    'home.stats.late_total_min': '{min}m total',

    'clock.pick_mode': 'Pilih mode kerja',
    'clock.in_now': 'Catat kehadiran',
    'clock.out_now': 'Selesaikan kehadiran',
    'clock.btn_in': 'Clock-in sekarang',
    'clock.btn_out': 'Clock-out sekarang',
    'clock.note_placeholder': 'Catatan (opsional)',
    'clock.visit_target_placeholder': 'Tujuan kunjungan / nama klien',
    'clock.visit_target_required': 'Tujuan kunjungan harus diisi.',
    'clock.visit_photo': 'Foto bukti (opsional)',
    'clock.visit_photo_pick': 'Pilih atau ambil foto',
    'clock.visit_photo_ready': '✓ Foto siap dikirim',
    'clock.uploading': 'Mengunggah…',
    'clock.toast_in': 'Berhasil clock-in.',
    'clock.toast_out': 'Berhasil clock-out. Sampai besok!',
    'clock.toast_failed': 'Gagal melakukan absensi.',
    'clock.toast_in_other_ws': 'Berhasil clock-in di workspace {name}.',
    'clock.toast_out_other_ws': 'Berhasil clock-out di workspace {name}.',
    'clock.processing': 'Memproses…',

    // GPS preview
    'gps.detecting': 'Mendeteksi lokasi…',
    'gps.not_detected': 'Lokasi belum dideteksi.',
    'gps.detect_now': 'Deteksi sekarang',
    'gps.in_office': 'Berada di {name}',
    'gps.distance_from_office': '{meters}m dari {name}',
    'gps.in_radius': 'Dalam radius kantor ({meters}m)',
    'gps.outside_radius': 'Di luar radius — pilih WFH atau WFA',
    'gps.no_office': 'Belum ada kantor terdaftar. Hubungi admin.',
    'gps.no_office_title': 'Lokasi kantor belum diatur',
    'gps.no_office_body': 'Owner workspace belum mendaftarkan lokasi kantor. Pakai mode WFH atau WFA dulu, atau hubungi admin untuk daftarkan kantor.',
    'gps.switch_wfh': 'Pindah ke WFH',
    'gps.switch_wfa': 'Pindah ke WFA',
    'clock.block_no_office': 'Mode kantor belum bisa dipakai — belum ada lokasi kantor terdaftar.',
    'clock.block_out_of_radius': 'Kamu di luar radius kantor. Pindah ke WFH/WFA atau dekati lokasi kantor.',

    // History
    'history.7d': 'Riwayat 7 hari terakhir',
    'history.empty': 'Belum ada riwayat absensi.',
    'history.this_week': 'Minggu ini',
    'history.this_week_summary': '{present} hadir',
    'history.this_week_late': '{count} telat',
    'history.late_short': '+{min}m telat',
    'history.overtime_short': '+{duration} lembur',

    // Status
    'status.present': 'Hadir',
    'status.late': 'Telat',
    'status.incomplete': 'Belum selesai',
    'status.remote': 'Remote',

    // Overtime
    'ot.title': 'Pengajuan',
    'ot.subtitle': 'Lembur, justifikasi telat, reimbursement, kunjungan.',
    'ot.btn_new': 'Ajukan baru',
    'ot.empty': 'Belum ada pengajuan. Tap "Ajukan baru" untuk mulai.',
    'ot.filter_all_types': 'Semua jenis',
    'ot.filter_all_status': 'Semua status',

    'ot.type.overtime': 'Lembur',
    'ot.type.lateness_excuse': 'Justifikasi telat',
    'ot.type.reimbursement': 'Reimburse',
    'ot.type.visit': 'Kunjungan',
    'ot.type.sick_leave': 'Sakit',
    'ot.type.permission_leave': 'Izin (tidak masuk)',
    'ot.type.annual_leave': 'Cuti tahunan',
    'ot.type.maternity_leave': 'Cuti melahirkan',

    'ot.status.pending': 'Menunggu',
    'ot.status.approved': 'Disetujui',
    'ot.status.rejected': 'Ditolak',
    'ot.status.cancelled': 'Dibatalkan',

    // Riwayat Izin & Cuti (pegawai)
    'leave.title': 'Riwayat Izin & Cuti',
    'leave.subtitle': 'Pengajuan sakit, izin, dan cuti kamu beserta statusnya.',
    'leave.home_hint': 'Lihat sisa cuti & riwayat pengajuanmu',
    'leave.annual_quota': 'Sisa cuti tahunan',
    'leave.annual_used': '{used} hari sudah terpakai tahun ini',
    'leave.days': 'hari',
    'leave.days_count': '{n} hari',
    'leave.summary_hint': 'Rekap hari yang disetujui sepanjang {year}.',
    'leave.filter_all_types': 'Semua jenis',
    'leave.filter_all_status': 'Semua status',
    'leave.empty': 'Belum ada pengajuan izin atau cuti.',

    'ot.form.title': 'Pengajuan baru',
    'ot.form.type': 'Jenis pengajuan',
    'ot.form.team': 'Tim',
    'ot.form.team_placeholder': 'Pilih tim',
    'ot.form.team_required': 'Pilih tim dulu.',
    'ot.form.from': 'Mulai',
    'ot.form.to': 'Selesai',
    'ot.form.leave_from': 'Tanggal mulai',
    'ot.form.leave_to': 'Tanggal selesai',
    'ot.form.from_required': 'Tanggal mulai diperlukan.',
    'ot.form.from_date_placeholder': 'Pilih tanggal mulai',
    'ot.form.to_date_placeholder': 'Pilih tanggal selesai',
    'ot.form.sick_note': 'Surat keterangan sakit (opsional)',
    'ot.form.sick_note_hint': 'Pilih atau ambil foto/PDF',
    'ot.form.annual_remaining': 'Sisa cuti tahunan: {n} hari',
    'ot.form.annual_used': '{used} dari {quota} hari terpakai',
    'ot.form.annual_hint': 'Sisa kuota cuti tahunan kamu akan dicek oleh penyetuju.',
    'ot.form.hours': 'Jumlah jam',
    'ot.form.category': 'Kategori',
    'ot.form.amount': 'Nominal (Rp)',
    'ot.form.location': 'Lokasi',
    'ot.form.location_placeholder': 'Nama tempat / klien',
    'ot.form.reason': 'Alasan / keterangan',
    'ot.form.reason_placeholder': 'Jelaskan singkat alasan pengajuan',
    'ot.form.attachments': 'Lampiran (foto/PDF)',
    'ot.form.submit': 'Kirim pengajuan',
    'ot.form.toast_submitted': 'Pengajuan terkirim. Menunggu approval.',

    'ot.detail.requester': 'Pemohon',
    'ot.detail.from': 'Mulai',
    'ot.detail.to': 'Selesai',
    'ot.detail.reviewed_by': 'Direview oleh',
    'ot.detail.cancel_request': 'Batalkan pengajuan',
    'ot.detail.confirm_cancel': 'Yakin batalkan pengajuan?',
    'ot.detail.toast_cancelled': 'Pengajuan dibatalkan.',
    'ot.detail.no_attachments': 'Tidak ada lampiran.',
    'ot.detail.approve': 'Setujui',
    'ot.detail.reject': 'Tolak',
    'ot.detail.reject_prompt': 'Alasan penolakan:',
    'ot.detail.toast_approved': 'Pengajuan disetujui.',
    'ot.detail.toast_rejected': 'Pengajuan ditolak.',
    'ot.detail.toast_review_failed': 'Gagal memproses. Coba lagi.',
    'ot.detail.waiting_level': 'Menunggu approver level {level} dari {total}',
    'ot.detail.level_n': 'Level {n}',

    // Tukar shift (shift swap) — pegawai
    'swap.title': 'Tukar shift',
    'swap.subtitle': 'Minta tukar jadwal shift di satu tanggal dengan rekan kerja.',
    'swap.home_title': 'Tukar shift',
    'swap.home_hint': 'Ajukan tukar jadwal shift dengan rekan',
    'swap.target': 'Tukar dengan',
    'swap.target_placeholder': 'Pilih rekan kerja',
    'swap.date': 'Tanggal shift',
    'swap.date_placeholder': 'Pilih tanggal',
    'swap.reason': 'Alasan (opsional)',
    'swap.reason_placeholder': 'Misal: ada keperluan keluarga',
    'swap.submit': 'Ajukan tukar shift',
    'swap.err_target': 'Pilih rekan untuk tukar shift.',
    'swap.err_date': 'Pilih tanggal shift.',
    'swap.toast_created': 'Permintaan tukar shift terkirim.',
    'swap.toast_failed': 'Gagal mengajukan tukar shift.',
    'swap.my_requests': 'Permintaan tukar shift saya',

    // Payslip
    'payslip.title': 'Slip Gaji',
    'payslip.subtitle': 'Slip gaji bulanan kamu, dengan rincian PPh21 + komponen.',
    'payslip.empty': 'Belum ada slip gaji.',
    'payslip.empty_hint': 'Slip akan muncul setelah admin generate payroll bulanan.',
    'payslip.period': 'Periode',
    'payslip.basic_salary': 'Gaji pokok',
    'payslip.overtime_pay': 'Lembur',
    'payslip.overtime_breakdown': 'Rincian lembur',
    'payslip.ot_weekday_first': 'Jam ke-1 (hari kerja)',
    'payslip.ot_weekday_after': 'Jam berikutnya (hari kerja)',
    'payslip.ot_weekend': 'Hari libur / akhir pekan',
    'payslip.ot_holiday': 'Hari libur nasional',
    'payslip.ot_night': 'Premi malam',
    'payslip.ot_minutes': '{m} mnt',
    'payslip.ot_multiplier': '×{x}',
    'payslip.ot_capped': 'Dibatasi (batas mingguan)',
    'payslip.reimbursement': 'Reimbursement',
    'payslip.unpaid_leave_deduction': 'Potongan izin tanpa bayar',
    'payslip.unpaid_leave_days': '{d} hari',
    'payslip.lateness_deduction': 'Potongan telat',
    'payslip.pph21': 'PPh21',
    'payslip.gross': 'Bruto',
    'payslip.net': 'Gaji bersih',
    'payslip.download_pdf': 'Unduh PDF',
    'payslip.status.draft': 'Draft',
    'payslip.status.finalized': 'Difinalisasi',
    'payslip.status.paid': 'Dibayar',

    // Verifikasi wajah (anti-fraud)
    'face.enroll_title': 'Daftarkan Wajah',
    'face.enroll_subtitle': 'Sekali daftar, wajahmu dipakai untuk memverifikasi setiap absen. Posisikan wajah di dalam bingkai dengan pencahayaan cukup.',
    'face.capture': 'Ambil & Daftarkan',
    'face.recapture': 'Daftar Ulang Wajah',
    'face.analyzing': 'Menganalisis wajah…',
    'face.loading_models': 'Menyiapkan pendeteksi wajah…',
    'face.no_face': 'Wajah tidak terdeteksi. Pastikan wajah jelas & terang.',
    'face.enroll_success': 'Wajah berhasil didaftarkan.',
    'face.enroll_failed': 'Gagal mendaftarkan wajah. Coba lagi.',
    'face.error_models': 'Gagal memuat model wajah. Cek koneksi internet.',
    'face.error_camera': 'Tidak bisa mengakses kamera. Izinkan akses kamera lalu coba lagi.',
    'face.error_generic': 'Terjadi kendala. Coba lagi.',
    'face.done_title': 'Wajah terdaftar!',
    'face.done_body': 'Mulai sekarang absenmu akan diverifikasi otomatis.',
    'face.back_home': 'Kembali ke beranda',
    'face.already_enrolled_title': 'Wajah sudah terdaftar',
    'face.already_enrolled_body': 'Daftar ulang hanya jika wajahmu sangat berubah atau verifikasi sering gagal.',
    'face.privacy_note': 'Yang disimpan hanya pola matematis wajah (angka), bukan foto. Dipakai khusus untuk verifikasi absensi.',
    'face.card_setup_title': 'Aktifkan verifikasi wajah',
    'face.card_setup_hint': 'Daftarkan wajahmu agar absen lebih aman & anti-titip.',
    'face.card_enrolled_title': 'Verifikasi wajah aktif',
    'face.card_enrolled_hint': 'Absenmu diverifikasi otomatis. Ketuk untuk daftar ulang.',

    // PWA
    'pwa.install_title': 'Pasang ke home screen',
    'pwa.install_body': 'Akses lebih cepat tanpa buka browser. 1x install, langsung jalan.',
    'pwa.install_btn': 'Pasang',
    'pwa.install_dismiss': 'Nanti saja',
    'pwa.ios_title': 'Pasang di iPhone',
    'pwa.ios_step1': 'Tap tombol Share di Safari',
    'pwa.ios_step2': 'Pilih "Add to Home Screen"',

    // Push notif
    'push.optin_title': 'Aktifkan notifikasi',
    'push.optin_body': 'Reminder shift mulai, hasil approval, dan slip gaji ready dikirim langsung ke kamu.',
    'push.optin_btn': 'Aktifkan',
    'push.optin_dismiss': 'Lewati',
    'push.toast_enabled': 'Notifikasi aktif.',
    'push.toast_failed': 'Gagal aktifkan notifikasi.',

    // Errors
    'error.network': 'Tidak ada koneksi internet.',
    'error.offline_banner': 'Kamu sedang offline. Data mungkin tidak terbaru.',
};
